import { AdminPortalUserRole } from "@organization/models/OrganizationUserDetails";

export const countryEndpoints = {
  countries: () => "/countries"
};

export const bffEndpoints = {
  invalidateToken: () => "/v1/auth/token"
};

export const userEndpoints = {
  // Notes
  // GET /users/{userGUIDId} works OK w Frontdoor
  // GET /users/{email} does NOT work w Frontdoor
  // GET /users?email=abc@example.com works OK w Frontdoor
  getUserBy: () => `/users`,
  getUserByOrganizationId: (organizationId: string, userId: string) =>
    `/organizations/${organizationId}/users/${userId}`
};

export const organizationEndpoints = {
  uniqueCheck: (organizationName: string, organizationIdToExclude?: string) => {
    const paramPart = organizationIdToExclude
      ? `&organizationIdToExclude=${organizationIdToExclude}`
      : "";

    return "/organizations?name=" + organizationName + paramPart;
  },
  create: () => "/organizations",
  search: () => "/organizations",
  getOrganizationById: (organizationId: string) =>
    `/organizations/${organizationId}`,
  getExternalIds: (organizationId: string) =>
    `/organizations/${organizationId}/external-ids`,
  update: (organizationId: string, fieldName: string) =>
    `/organizations/${organizationId}/${fieldName}`
};

export const associateUserEndpoints = {
  associate: (organizationId: string) =>
    `/organizations/${organizationId}/users`,
  get: (organizationId: string) =>
    `/organizations/${organizationId}/users?organizationRoles=` +
    AdminPortalUserRole.OrganizationAdmin,
  disassociate: (organizationId: string, userId: string) =>
    `/organizations/${organizationId}/users/${userId}`
};

export const organizationApplicationEndpoints = {
  get: (organizationId: string) =>
    `/organizations/${organizationId}/applications`,
  update: (organizationId: string, applicationId: string) =>
    `/organizations/${organizationId}/applications/${applicationId}`
};

export const applicationEndPoints = {
  get: () => "/applications",
  associate: (applicationId: string, organizationId: string) =>
    `/applications/${applicationId}/organizations/${organizationId}`,
  disassociate: (applicationId: string, organizationId: string) =>
    `/applications/${applicationId}/organizations/${organizationId}`
};

export const resourceEndpoints = {
  getResources: () => "/resources",
  getResourceById: (resourceId: string) => `/resources/${resourceId}`,
  getResourceMetadataValuesByKey: (resourceId: string, metadataKey: string) =>
    `/resources/${resourceId}/metadata/${metadataKey}`,
  getResourcesMetadataDistinctValues: () => `/resources/metadata/values`,
  getResourcesRelationshipTypes: () => `/resources/relationship-types`
};

export const auditLogEndpoints = {
  getAuditLog: "/audit-log"
};
